import { ComponentParameterEnhancerFunction } from "@uniformdev/canvas";

import { ProductCatalogClient } from "@/contentful/product-catalog.tsx";

const PRODUCT_CATALOG_DELIVERY_KEY =
    process.env["PRODUCT_CATALOG_DELIVERY_KEY"];
const PRODUCT_CATALOG_SPACE = process.env["PRODUCT_CATALOG_SPACE"];

export const comparePlansEnhancer: ComponentParameterEnhancerFunction<
    Plan[]
> = async ({ parameter }) => {
    const plans = parameter.value;
    if (!plans?.length) {
        return parameter.value;
    }

    const productCatalogClient = new ProductCatalogClient(
        String(PRODUCT_CATALOG_DELIVERY_KEY),
        String(PRODUCT_CATALOG_SPACE),
        "master"
    );

    const skus = plans.map((plan) => plan.fields.sku);

    const ccpPricingData = await productCatalogClient.getCCPPricingData(skus);

    return plans.map((plan) => ({
        ...plan,
        pricingPlan: ccpPricingData[plan.fields.sku]
    }));
};

export type Plan = {
    fields: {
        sku: string;
    };
};
